/* LUVEE theme — cart drawer + AJAX add-to-cart */
(function () {
  const $ = (s) => document.querySelector(s);
  const overlay = $('#overlay'), drawer = $('#cart-drawer'), mnav = $('#m-nav');
  const money = (c) => '₹' + (c / 100).toLocaleString('en-IN');

  function openDrawer() { renderCart(); drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  function openMenu() { if (!mnav) return; mnav.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; const t = $('#menu-toggle'); if (t) t.setAttribute('aria-expanded', 'true'); }
  function closeMenu() { if (mnav) mnav.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; const t = $('#menu-toggle'); if (t) t.setAttribute('aria-expanded', 'false'); }
  function closeAll() { closeDrawer(); closeMenu(); }

  async function renderCart() {
    const body = $('#drawer-body'), foot = $('#drawer-foot');
    const cart = await fetch('/cart.js').then((r) => r.json());
    updateCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<p class="muted" style="text-align:center;padding:56px 20px">Your bag is empty.</p>';
      foot.innerHTML = ''; return;
    }
    body.innerHTML = cart.items.map((i) => `
      <div style="display:flex;gap:14px;padding:15px 0;border-bottom:1px solid var(--line)">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''}" alt="" style="width:70px;height:70px;object-fit:contain;background:#fff;border:1px solid var(--line);border-radius:8px;padding:5px">
        <div style="flex:1">
          <div style="font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--accent)">${i.vendor || ''}</div>
          <div style="font-size:14px;font-weight:600;line-height:1.3;margin:2px 0 6px">${i.product_title}</div>
          <div style="display:inline-flex;align-items:center;border:1px solid var(--line);border-radius:40px">
            <button data-qty="${i.key}" data-d="-1" style="width:28px;height:28px">−</button>
            <span style="width:30px;text-align:center;font-size:13px">${i.quantity}</span>
            <button data-qty="${i.key}" data-d="1" style="width:28px;height:28px">+</button>
          </div>
        </div>
        <div style="font-weight:600;font-size:14px;white-space:nowrap">${money(i.final_line_price)}</div>
      </div>`).join('');
    foot.innerHTML = `
      <div style="display:flex;justify-content:space-between;font-size:18px;font-weight:600;margin-bottom:12px"><span>Total</span><span>${money(cart.total_price)}</span></div>
      ${window.LUVEE.ordersOpen
        ? '<a href="/checkout" class="btn btn--block">Checkout</a>'
        : '<div style="background:var(--accent-soft);color:var(--accent-dark);font-size:13px;padding:10px 12px;border-radius:8px;text-align:center">We\'re not taking orders yet — launching soon.</div>'}`;
  }

  function updateCount(n) {
    const el = $('#cart-count'); if (!el) return;
    el.textContent = n; el.hidden = n === 0;
  }

  async function addToCart(id) {
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity: 1 }) });
    openDrawer();
  }
  async function changeQty(key, d) {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const item = cart.items.find((i) => i.key === key); if (!item) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, item.quantity + d) }) });
    renderCart();
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-add],[data-qty],#cart-toggle,#drawer-close,#menu-toggle,#m-nav-close');
    if (!t) return;
    if (t.dataset.add !== undefined) { e.preventDefault(); addToCart(+t.dataset.add); }
    else if (t.dataset.qty !== undefined) { changeQty(t.dataset.qty, +t.dataset.d); }
    else if (t.id === 'cart-toggle') { e.preventDefault(); openDrawer(); }
    else if (t.id === 'drawer-close') { closeDrawer(); }
    else if (t.id === 'menu-toggle') { e.preventDefault(); openMenu(); }
    else if (t.id === 'm-nav-close') { closeMenu(); }
  });
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
})();
